import logrocketNode from "./node";
import logrocketBrowser from "./browser";

export default typeof Window ? logrocketBrowser : logrocketNode;
